import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss?v=1.2.0";
import "assets/demo/demo.css?v=1.2.0";
// pages
// import SkillX from "views/examples/SkillX.js";
// import FineTuneTalks from "views/examples/FineTuneTalks.js";
import BootCamp from "views/examples/BootCamp.js";
import NotFound from "views/examples/NotFound.js";
import OutReach from "views/examples/OutReach"

ReactDOM.render(
    <BrowserRouter>
        <Switch>
            <Route
                exact
                path="/"
                render={(props) => <OutReach {...props} />}
            />
            <Route
                exact
                path="/bootcamp150"
                render={(props) => <BootCamp {...props} />}
            />
            <Route path='/step_1' component={() => { 
                window.location.href = 'https://www.instagram.com/tv/CRbqnJcA6hF'; 
                return null;
            }}/>
            <Route path='/step_2' component={() => { 
                window.location.href = 'https://sdgs.un.org/goals'; 
                return null;
            }}/>
            <Route path='/step_3' component={() => { 
                window.location.href = 'https://docs.google.com/document/d/1jDvSji2EG6r2FEXRuDfehvuTwo9g3G94Gq9Jaccr6JQ/edit?usp=sharing'; 
                return null;
            }}/>
            <Route path='/step_4' component={() => { 
                window.location.href = 'https://forms.gle/Ym5ZxGbxYwk9DBqv7'; 
                return null;
            }}/>
            <Route component={NotFound} />
        </Switch>
    </BrowserRouter>,
    document.getElementById("root")
);
